import { configureStore } from "@reduxjs/toolkit";
import shoppingPartners from "./slices/ShoppingPartnersSlices"
import AuthSlice from "./slices/AuthSlice"
import PermissionsSlices from "./slices/PermissionsSlice";
import BusinessesSlices from "./slices/BusinessesSlice";
import DepartmentsSlice from "./slices/DepartmentsSlice";
import InventorySlices from "./slices/InventorySlice";
import { combineReducers } from "redux";
import thunk from "redux-thunk";
import LedgersSlices from "./slices/LedgersSlices"; 
import AttendancesSlice from "./slices/AttendancesSlice";
import InitialDataSlice from "./slices/InitialDataSlice";
import UserSlice from "./slices/UserSlice";
import ProcessMaster from "./slices/ProcessMaster";
import ProductsSlice from "./slices/ProductsSlice";
import BeatSlice from "./slices/BeatSlice";
import LeavesSlice from "./slices/LeaveSlice";
import OrdersSlice from "./slices/OrdersSlice";
import SchemeSlice from "./slices/SchemeSlice";
import stockSlice from "./slices/StockSlice";

const logger = store => next => action => {
  // console.log("dispatching", action);
  let result = next(action);
  return result;
};

export default configureStore({
  reducer: combineReducers({
    shoppingPartners: shoppingPartners,
    auth: AuthSlice,
    permissions: PermissionsSlices,
    initialData: InitialDataSlice,
    businesses: BusinessesSlices,
    ledgers: LedgersSlices,
    departments: DepartmentsSlice,
    attendance:  AttendancesSlice,
    inventory: InventorySlices,
    processMaster: ProcessMaster,
    users:  UserSlice,
    products: ProductsSlice,
    beats: BeatSlice,
    leaves: LeavesSlice,
    orders: OrdersSlice,
    scheme: SchemeSlice,
    stock: stockSlice
        
  }),
  middleware: [logger, thunk]
})